import React, { useState, useContext, useEffect } from 'react';
import { ChangeEvent } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import selectors from '@state/selectors';
import {IProps, IState} from './types';
import * as S from './styles';
import { Context } from "routes/private/Editor/Context";
import { IDSConfig } from '@state/dsconfig/types';
import { IBrandDefinition } from '@state/dsconfig/types';
import { findDifferentAttributeValues, findElementById } from "@utils/editor";
import {IElement, IPickerColorProperties, IShapeCircleAttributes, IShapeEllipseAttributes, IShapeRectangleAttributes, IShapeTriangleAttributes, ITextAttributes, IColorGradient, IColorStop, IGradientStyle} from 'routes/private/Editor/types';
import addColor from 'assets/pngs/addColor.png';
import {findOEM,hasAtLeastOneElementType} from '@utils/editor';
import ColorGenerator from 'components/ColorGenerator';
import "./colorgenstyles.css";
import Input from '@components/Input';
import C from '@assets/themes/colors';
import actions from '@state/actions';
import { hexFormat, transformToHex } from '@utils/colors';
import { getSelectedColor } from '@utils/colors';
import { getOEMName } from 'utils/editor'
import {CircularInput,CircularTrack,CircularProgress,CircularThumb} from 'react-circular-input'
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { otherElementHasColor } from '@utils/colors';
import ComboBox from '@components/ComboBox';
import Slider from '@components/Slider';
import GradientStopsControl from '@components/GradientStopsControl';
import { isEditingText } from '@utils/text';
import { validateNumbers } from '@utils/userUtils';


const ColorPicker:React.FC<IProps> = (props) => {      
    const authContext = useContext(AuthContext);
    let context = useContext(Context);
    const dispatch = useDispatch();
    const dsConfig: IDSConfig | undefined = useSelector(selectors.dsConfig.getDSConfig);
    const [focusedInputId, setFocusedInputId] = useState<string | undefined>(undefined);
    const [sliderInputValue, setSliderInputValue] = useState<string | undefined>(undefined);
    const [color,setColor] = useState<string|undefined>();
    const oem = findOEM(context.entityInformation);
    const [oemColors,setOEMColors] = useState<string[] | undefined>();
    const [showColorGenerator,setShowColorGenerator] = useState(false);
    const [customColor, setCustomColor]= useState("#894646");
    const [cmd, setCmd] = useState<string|undefined>();
    const elementType = props.pickerProperties?(props.pickerProperties as IPickerColorProperties).elementType:(context.editorStatus.pickerProperties as IPickerColorProperties)!.elementType    
    const colorAttr = props.pickerProperties?(props.pickerProperties as IPickerColorProperties).colorAttribute:(context.editorStatus.pickerProperties as IPickerColorProperties)!.colorAttribute    
    const dealerUserData = authContext && authContext.userData?authContext.userData.profile:undefined;const [gradient, setGradient] = useState<boolean>(false)
    const [angle, setAngle] = useState<number| undefined>(0)
    const [inputAngle, setInputAngle] = useState<number| undefined>(0)
    const [circleVal, setCircleVal] = useState<number| undefined>(0)
    const [startOpacity, setStartOpacity] = useState<number | undefined>(0)
    const [endOpacity, setEndOpacity] = useState<number | undefined>(0)    
    const [startedComponent, setStartedComponent] = useState<boolean>(false)    
    const [triggerSave, setTriggerSave] = useState<boolean>(false);
    const [colorStops, setColorStops] = useState<IColorStop[]| undefined >(undefined); 
    const [colorStopIndex, setColorStopIndex] = useState<number>(0);
    const [gradientStyle, setGradientStyle] = useState<string | undefined>()
    const [scalar, setScalar] = useState<number | undefined>(0)
    const [offset, setOffset] = useState<any | undefined>({x:0,y:0})    
    const colorStyles = ["Solid", "Linear Gradient", "Radial Gradient"]
    const startSlider = 0;
    const minSlider = 0;
    const maxSlider = 100;
    const anglesArray :any = [];
    const minAngle=-180;
    const maxAngle = 180;
    let degreecount=90;
     for (let index = 0; index < 360; index++) {       
        const element = {
            value: index,
            degree: degreecount
        };
        if (degreecount>minAngle)
            degreecount--;
        else
            degreecount = maxAngle;
        anglesArray.push(element);        
    }

    


    useEffect(() => {
        if ((props.elementsIds && props.pickerProperties && props.pickerProperties.elementType && props.pickerProperties.colorAttribute) || (context && context.editorStatus && context.editorStatus.pickerProperties && (context.editorStatus.pickerProperties as IPickerColorProperties).elementType  && (context.editorStatus.pickerProperties as IPickerColorProperties).colorAttribute)) {
            let colorValue: string | undefined = undefined;
            if(props.elementsIds && props.pickerProperties) {                        
                colorValue = getSelectedColor(props.elementsIds,props.pickerProperties.elementType,props.pickerProperties.colorAttribute,context.data);
            }
            else {
                if ((context.editorStatus.pickerProperties as IPickerColorProperties)?.elementType === "Text") {
                    const textColors = findDifferentAttributeValues(context.editorStatus.selectedElementsId, context.data, "color", "Text", context.editorStatus.textSelectionInformation);
                    if (textColors.length) {
                        let rgbColor = `${textColors[0]}`;
                        colorValue = transformToHex(rgbColor);
                    }
                } else
                colorValue = getSelectedColor(context.editorStatus.selectedElementsId,(context.editorStatus.pickerProperties as IPickerColorProperties)?.elementType,(context.editorStatus.pickerProperties as IPickerColorProperties)?.colorAttribute,context.data);
            }
            if (colorValue) {
                setColor(colorValue);
                setCustomColor(colorValue);
            }
            const elementType = (props.pickerProperties?props.pickerProperties.elementType:(context.editorStatus.pickerProperties as IPickerColorProperties)?.elementType); 
            setCmd(elementType==="Text"?"color":(props.pickerProperties?.colorAttribute ==="borderColor"?"borderColor":"bgcolor"));
            if (!props.pickerProperties && !hasAtLeastOneElementType(context.editorStatus.selectedElementsId,context.data,elementType)) {
                context.onShowPicker(undefined);
            }     
            if (colorAttr ==="backgroundColor")       
                getSelectedGradient(context.editorStatus.selectedElementsId,elementType,"bgGradient",context.data);
        }
        else {            
            setColor(undefined);
            setCmd(undefined);
            context.onShowPicker(undefined);
        }
    }, [JSON.stringify({pickerProps: props.pickerProperties, editorPickerProps: context.editorStatus.pickerProperties, ids: context.editorStatus.selectedElementsId, text: context.editorStatus.textSelectionInformation})]);

    useEffect(() => {
        if(dsConfig){
            setOEMColors(findOEMColors(oem,(dsConfig as IDSConfig).brands));
        }
    }, [dsConfig])

    useEffect(() => {
       
        if (startedComponent)
            SetGradient(gradient,angle,startOpacity,endOpacity,gradientStyle,colorStops, scalar, offset, true);
    }, [angle]);
    


    useEffect(() => {
        if (gradient && colorStopIndex !== undefined && colorStops?.length) {
            setCustomColor(colorStops[colorStopIndex].color);
        }
    }, [colorStopIndex])

    const SetGradient = (gradient:boolean, angle?:number, startopacity?:number, endopacity?:number, style?:string, colorStops?:IColorStop[], scalar?:number, offset?:any, notSave?:boolean)=>{   
        if (context.editorStatus.selectedElementsId.length > 0)
        {
          
            let colorgradient: IColorGradient =
            {
                hasGradient: gradient,
                angle: angle,
                startOpacity: startopacity,
                endOpacity: endopacity,
                style: style== colorStyles[1]?"linear":style==colorStyles[2]?"radial":undefined,
                colorStops: colorStops,
                scale:scalar,
                offset: offset
            }                     
            context.onCommandChange("bgGradient", colorgradient, props.elementsIds,undefined,notSave);     
        }
    }


    const SetColorOnElement = async (colorToElement: string, save?: boolean) => {  
        const notSave: boolean = !triggerSave && !(save === true);
        if(cmd) await context.onCommandChange(cmd, colorToElement, props.elementsIds, undefined, notSave);     
        setColor(colorToElement);    
        if (save) setCustomColor(colorToElement);
        if(props.onChangeValue) props.onChangeValue(colorToElement); 
    }
    
    const handleDefineCustomColor = (e : any) => {
        setShowColorGenerator(!showColorGenerator)
    }

    const handleColorGeneratorChange = async (e : any) => {
        setStartedComponent(true)
        setCustomColor(e);
        if (gradient && colorStops?.length) {
            changeColorStopColor(true, e);
            return;
        }
        await SetColorOnElement(e);
    }

    const addOEMColor = () => {
        if (oem && oem!=="Other" && oem!=="Generic" && oemColors) {
            setOEMColors([...oemColors, customColor]);
        }
        const dealerUserData = {
            email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
            name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User",
            role: authContext?.userData.profile.role ? authContext?.userData.profile.role : "",
            organizations: authContext?.userData.profile.name ? authContext.userData.profile["dealeron.dealerorganization"] : []
        };
        return new Promise((resolve, reject) => {
            dispatch(actions.dsConfig.addOEMColor(oem??"", customColor, false, dealerUserData, (result: any, error: any) => {
                if (error) reject(error)
                else resolve(result)
            }))
        });
    }
    
    const handleEndChangeColor = async (e : any) => {
        if (gradient && colorStops?.length) {
            changeColorStopColor(false);
            return;
        }
        setTriggerSave(true);
    }

    useEffect(() => {
        if (triggerSave) {
            handleAddColor(customColor, false);
            setTriggerSave(false);
        }
    }, [triggerSave]);

    const handleAddColor = async (color: string, addToOEMColors: boolean) => {
        if (cmd) {
            if(addToOEMColors) {
                const runAddOEMColor = async () => await addOEMColor();   
                runAddOEMColor();
            }        
            else {
                await context.onColorAdded(color);
            }
            await SetColorOnElement(color);
        }
    }

    const handleAngleInput = (e: any, type:string, id?:string) => {
        setStartedComponent(true);
        const inputText = e.target.value;            
        if (!isNaN(inputText) && parseFloat(inputText)>=minAngle && parseFloat(inputText)<=maxAngle || inputText=="-")
            setInputAngle(inputText)        
        else 
            setInputAngle(0)

        
        if(inputText==="" || inputText==="-" || (!isNaN(inputText) && parseFloat(inputText)<minAngle)) {                     
            if (parseFloat(inputText)>=maxAngle)
            {
                if (type ==="angle")
                    handleCircleVal(0);     
            }

        }
       
    
        if(!isNaN(inputText) && parseFloat(inputText)>=minAngle) {
            if (parseFloat(inputText)<=maxAngle)
            {
                if (type ==="angle")
                    handleCircleVal(parseFloat(inputText));     
            }            
        }
      }


      const getSelectedGradient = (selectedElementsId: string[],elementType: string,gradientAttribute: string, data: IElement[]): string|undefined => {
        let colorgradient: IColorGradient | undefined = undefined;        
        if(selectedElementsId && selectedElementsId.length>0) {
            for(let i=0;i<selectedElementsId.length;i++){
                const element = findElementById(data, selectedElementsId[i]);
                if(element && element.type===elementType) {
                    if (colorgradient===undefined)
                        colorgradient = element.attributes[gradientAttribute];                    
                }
            }        
        }

        if (colorgradient!=undefined)
        {
            setGradient(colorgradient.hasGradient??false);        
            setInputAngle(Math.round(colorgradient.angle??0))    
            handleCircleVal(Math.round(colorgradient.angle??0));            
            setStartOpacity(colorgradient.startOpacity);
            setEndOpacity(colorgradient.endOpacity);
            setColorStops(colorgradient.colorStops)
            setGradientStyle(colorgradient.style=="linear"?colorStyles[1]:colorgradient.style=="radial"?colorStyles[2]:colorStyles[0])
            setScalar(colorgradient.scale);
            setOffset(colorgradient.offset);
        }
        else
        {
            setGradient(false);
            setInputAngle(0)
            handleCircleVal(0);            
            setStartOpacity(0);
            setEndOpacity(0);
            setColorStops([])
            setGradientStyle(colorStyles[0])
            setScalar(0);
            setOffset(undefined);
        }

        return color;
    }
    
    const handleAngle= (value:number) =>{
        setStartedComponent(true);
        setCircleVal(value);
        let angleval = Math.round(value * 360)
        if (anglesArray)
        {
            let angleelement = anglesArray.find((f:any) => f.value === angleval)
            if (angleelement)
            {
                setInputAngle(angleelement.degree)
                setAngle(angleelement.degree)
                return angleelement.degree;
            }
        }
    }

    const handleCircleVal= (value:number) =>{              
        setAngle(value);         
        if (anglesArray)
        {
            let angleelement = anglesArray.find((f:any) => f.degree == value)            
            if (angleelement)
                setCircleVal(angleelement.value/360)
        }
    }

    const saveAngle = (value: number)=>{

        SetGradient(gradient,handleAngle(value),startOpacity,endOpacity, gradientStyle,colorStops);
          
    }

    const getDefaultColorStops=()=>{
        if (color)
        {
            let colordef =[{color:color,location:0,opacity:1},{color:color,location:1,opacity:0}]; 
            setColorStops(colordef);
            return colordef;
        }
        else
            return colorStops;
    }

    const handleGradientStyle = (id:string, value:string)=>{

        setGradientStyle(value)        
        if (value==colorStyles[0])//solid
        {
            setGradient(false)
            SetGradient(false,angle,startOpacity,endOpacity);
        }
        else        
        {
            setGradient(true)
            SetGradient(true,angle,startOpacity,endOpacity, value,getDefaultColorStops());
        }
    }

    const handleChangeSliders = (id: string, value: number, after: boolean) => {
        setStartedComponent(true);
        value = parseFloat((value / 100).toFixed(2));
        if (id === "opacity") {
            changeColorStopOpacity(!after, value);
        } else if (id === "scalar") {
            handleScalar(value, !after);
        } else if (id === "offset-x" || "offset-y") {
            let newOffset = {x: offset?.x ?? 0, y: offset?.y ?? 0};
            if (id === "offset-x") newOffset.x = value;
            else newOffset.y = value;
            handleOffset(newOffset, !after);
        }
    }

    const handleColorStops = (newColorStops: IColorStop[], notSave: boolean) => {
        setColorStops(newColorStops);
        SetGradient(gradient, angle, startOpacity, endOpacity, gradientStyle, newColorStops, scalar, offset, notSave);
    }

    const handleScalar = (newScalar: number, notSave: boolean)=>{
        setScalar(newScalar)
        SetGradient(gradient,angle,startOpacity,endOpacity,gradientStyle,colorStops, newScalar, offset, notSave);
    }

    const handleOffset = (newOffset: {x: number, y: number}, notSave: boolean)=>{            
        setOffset(newOffset)
        SetGradient(gradient,angle,startOpacity,endOpacity,gradientStyle,colorStops,scalar,newOffset, notSave);
    }

    const changeColorStopColor = (notSave: boolean, newColor?: string) => {
        if (colorStops && colorStopIndex !== undefined) {
            let newColorStops = [...colorStops];
            if (newColor && colorStopIndex !== undefined) {
                newColorStops[colorStopIndex].color = newColor;
            }
            handleColorStops(newColorStops, notSave);
        }
    }

    const changeColorStopOpacity = (notSave: boolean, opacity: number) => {
        if (colorStops && colorStopIndex !== undefined) {
            let newColorStops = [...colorStops];
            newColorStops[colorStopIndex].opacity = opacity;
            handleColorStops(newColorStops, notSave);
        }
    }

    const deleteColorStop = (index: number) => {
        if (colorStops && colorStops.length > 1 && index >= 0 && index < colorStops.length) {
            let newColorStops = [...colorStops];
            newColorStops.splice(index, 1);
            handleColorStops(newColorStops, false);
            setColorStopIndex(index === colorStops.length - 1 ? index - 1 : index);
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if ((e.keyCode||e.charCode) === 13) {
            finishInputChange();
            return;
        }
        if (!((e.keyCode||e.charCode) === 8 || (e.keyCode || e.charCode) === 46) || focusedInputId) return;
        if (context.editorStatus.isPickerFocused) deleteColorStop(colorStopIndex);
    }

    const finishInputChange = () => {
        if (sliderInputValue !== undefined && focusedInputId !== undefined) {
            const number = parseInt(sliderInputValue);
            if (!Number.isNaN(number))
                handleChangeSliders(focusedInputId, number, true);
            setFocusedInputId(undefined);
        }
    }

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
        if (e.target.value.length > 4) return;
        if (["", "-"].includes(e.target.value)) {
            setSliderInputValue(e.target.value);
            return;
        }
        let number = parseInt(e.target.value);
        if (id === "opacity") {
            if (number > 100) number = 100;
            else if(number < 0) number = 0;
        } else if (id === "scalar") {
            if (number > 500) number = 500;
            else if(number < 5) number = 5;
        } else if (id === "offset-x" || "offset-y") {
            if (number > 100) number = 100;
            else if(number < -100) number = -100;
        }
        setSliderInputValue(number.toString());
    }

    const handleInputFocus = (e: React.FocusEvent<HTMLInputElement>, id: string, value: string) => {
        setFocusedInputId(id);
        setSliderInputValue(value);
    }

    const handleInputBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        finishInputChange();
    }

    const getOpacityValue = () => {
        if (colorStops?.length && colorStopIndex !== undefined) {
            const colorStop = colorStops[colorStopIndex];
            return colorStop?.opacity !== undefined ? colorStop.opacity * 100 : 100;
        }
        return 100;
    }

    const renderSlider = (id: string, title: string, value: number, min: number, max: number) => {
        return (
            <S.optionContainer>
                <S.SliderTextContainer>
                <S.Label>
                    {title}
                </S.Label>
                <S.InputSlider
                    id={`gradient-${id}-input`}
                    onFocus={(e) => handleInputFocus(e, id, value.toString())}
                    onBlur={handleInputBlur}
                    onKeyPress={validateNumbers}
                    onPaste={validateNumbers}
                    value={id === focusedInputId ? sliderInputValue : value}
                    onChange={(e) => handleInputChange(e, id)}
                ></S.InputSlider>
                </S.SliderTextContainer>
                <S.SliderContainer>
                    <Slider
                        id={id}
                        onChange={handleChangeSliders}
                        slider={{
                            min,
                            max,
                            step: 1,
                            startPoint: startSlider,
                            value: value,
                        }}
                    />
                </S.SliderContainer>                 
            </S.optionContainer>
        );
    }
    
    const showDealerBrandsColors = dealerUserData?.role==='DealerUser' && (oem !== undefined && oem !== "Other" && oem !== "Generic");

    return (
        <S.Root
            tabIndex={0}
            onKeyDown={handleKeyDown}
        >
            {
                (elementType === "Shape"  && colorAttr ==="backgroundColor") &&
                <ComboBox 
                id="gradientStyle"
                placeholder="Style"
                options={["Solid","Linear Gradient","Radial Gradient"]}
                required={false}
                disabled={false}
                position={"bottom"}
                chooseOption={handleGradientStyle}
                value={gradientStyle}
                optionContainerStyle={{                   
                   
                   margin: "-28px 10px 0 10px",
                   width: "92%"  
                }}
                containerStyle={{
                    padding: "0 0 0 10px",                   
                    width: "92%"

                  }}
                boxContainerStyle={{'height': '40px'}}
                />
            }

            {
                (showColorGenerator || gradient) &&
                <S.ColorGeneratorContainer drawBox={props.drawBox}>
                    <S.ColorGeneratorBox drawBox={props.drawBox}>
                        <section className="colorgen">
                            <ColorGenerator show={showColorGenerator || gradient} color={customColor} showInputText={true} onChange={handleColorGeneratorChange} onEndChangeColor={handleEndChangeColor}>
                            </ColorGenerator>
                        </section>
                        {/* {
                            (oem && oem!=="Other" && oem!=="Generic" && !gradient) && 
                            <S.AddOEMSection>
                                <S.ColorGeneratorButton onClick={() => handleAddColor(customColor, true)}>
                                    <S.ColorGeneratorButtonText>
                                        Add to OEM Colors
                                    </S.ColorGeneratorButtonText>
                                </S.ColorGeneratorButton>
                            </S.AddOEMSection>
                        } */}
                    </S.ColorGeneratorBox>
                </S.ColorGeneratorContainer>    
            }    

            {
                gradient &&
                <GradientStopsControl
                    selectedIndex={colorStopIndex}
                    setSelectedIndex={setColorStopIndex}
                    colorStops={colorStops ?? []}
                    handleColorStops={handleColorStops}
                />
            }

            {
                !gradient &&
                <S.CommonColorContainer>
                    <S.Title>
                        Color Styles
                    </S.Title>
                    <S.SquaresContainer>
                        <S.AddColor>
                            <img src={addColor} onClick={handleDefineCustomColor}></img>
                        </S.AddColor>
                        {
                            context.colorPalette.map((genericColor) => {
                                return (
                                    <S.Square color={genericColor} onClick={(e) => SetColorOnElement(genericColor, true)} selected={(color && color===hexFormat(genericColor)) ? true : false}>
                                    </S.Square>
                                )
                            })
                        }
                    </S.SquaresContainer>
                </S.CommonColorContainer>
            }

            {
                oem && oem!=="Other" && oem!=="Generic" && oemColors && !gradient &&
                <S.OEMColorContainer>
                    <S.Title>
                        {getOEMName(oem, dsConfig)} Colors
                    </S.Title>
                    <S.SquaresContainer>
                        {
                            oemColors.map((oemColor) => {
                                return (
                                    <S.Square color={oemColor} onClick={(e) => SetColorOnElement(oemColor, true)} selected={(color && color===hexFormat(oemColor)) ? true : false}>
                                    </S.Square>
                                )
                            })
                        }
                    </S.SquaresContainer>
                </S.OEMColorContainer>
            }           
            {
                gradient &&
                <>
                    { renderSlider("opacity", "Opacity", getOpacityValue(), 0, 100) }
                    {
                        gradientStyle == colorStyles[1] &&
                        <S.optionContainer>
                        <S.SliderTextContainer>
                            <S.Label>
                                Opacity Angle
                            </S.Label>
                            <S.InputAngle                        
                                value={inputAngle??0}
                                onChange={(e)=>handleAngleInput(e, "angle")}
                            ></S.InputAngle>
                            °                    
                            </S.SliderTextContainer>
                            <S.CircularContainer>
                                
                                    <CircularInput 
                                        radius={10}
                                        value={circleVal??0} onChange={(e)=> handleAngle(e)} onChangeEnd={(e)=>saveAngle(e)} >
                                        <CircularTrack stroke="lightgray"  />			            
                                        <CircularThumb r={4} fill="gray" / >
                                    </CircularInput>
                                
                            </S.CircularContainer>
                        </S.optionContainer>
                    }
                    {                    
                        gradientStyle == colorStyles[2] &&
                        <>
                            { renderSlider("scalar", "Scalar", scalar !== undefined ? scalar * 100 : 100, 5, 500) }
                            { renderSlider("offset-x", "X Offset", offset?.x !== undefined ? offset.x * 100 : 0, -100, 100) }
                            { renderSlider("offset-y", "Y Offset", offset?.y !== undefined ? offset.y * 100 : 0, -100, 100) } 
                        </>
                    }
                </>
            }
            {
                (oem === undefined || oem === "Other" || oem === "Generic" || showDealerBrandsColors) && !gradient &&
                <S.OEMColorsContainer>
                    {
                        dsConfig?.brands?.map(oemEntity => {
                            const showColors =  showDealerBrandsColors ? !oemEntity.oem ? true : false : true;
                            if (oemEntity.id && oemEntity.colorPalette?.length && showColors ) return (
                                <S.OEMColorContainer
                                >
                                    <S.Title>
                                        {oemEntity.name} Colors
                                    </S.Title>
                                    <S.SquaresContainer>
                                        {
                                            oemEntity.colorPalette.map((oemColor) => {
                                                return (
                                                    <S.Square color={oemColor} onClick={(e) => SetColorOnElement(oemColor, true)} selected={(color && color===hexFormat(oemColor)) ? true : false}>
                                                    </S.Square>
                                                )
                                            })
                                        }
                                    </S.SquaresContainer>
                                </S.OEMColorContainer>
                            )
                        })
                    }
                </S.OEMColorsContainer>
            }
        </S.Root>
    );

    function findOEMColors(oem: string | undefined, oemDefinitions: IBrandDefinition[]): string[] | undefined {
        if(!oem) {
            return undefined;
        }
        if(oemDefinitions && oemDefinitions.length>0)
        {
            return oemDefinitions.find((oemDefinition)=>{
                return oemDefinition.id === oem
            })?.colorPalette;
        }
        return undefined;
    }

}

export default ColorPicker;
